import { sparkline } from "../analytics";

const WIDTH = 120;
const HEIGHT = 28;

/**
 * A small trend line (the `dataviz` stat-tile trend): the line in the muted
 * ink, the latest value in the accent, a tooltip per bucket. Gaps where the
 * rollup built nothing.
 */
export function Sparkline({
  label,
  buckets,
  values,
  format,
}: {
  label: string;
  buckets: readonly string[];
  values: readonly (number | null)[];
  format: (bucket: string, value: number | null) => string;
}) {
  const line = sparkline(values, WIDTH, HEIGHT);
  const slot = WIDTH / Math.max(1, values.length);
  return (
    <svg className="spark" viewBox={`0 0 ${WIDTH} ${HEIGHT}`} role="img" aria-label={label}>
      {line.runs.map((points) =>
        points.includes(" ") ? (
          <polyline key={points} className="spark-line" points={points} />
        ) : (
          <circle key={points} className="spark-dot" cx={points.split(",")[0]} cy={points.split(",")[1]} r={1.5} />
        ),
      )}
      {line.last && <circle className="spark-last" cx={line.last.x} cy={line.last.y} r={2.5} />}
      {buckets.map((bucket, index) => (
        <rect key={bucket} className="chart-hit" x={line.xs[index]! - slot / 2} y={0} width={slot} height={HEIGHT}>
          <title>{format(bucket, values[index] ?? null)}</title>
        </rect>
      ))}
    </svg>
  );
}
